module.exports = __webpack_public_path__ + "static/img/profile-icon10.fbb2402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon10.png
// module id = 2958
// module chunks = 1